// extracted by mini-css-extract-plugin
export default {"container":"to-z","blurb":"uo-z","links":"vo-z"};